import * as actions from "../actionTypes"

// pageDocs is { first: <doc>, last: <doc> } for that page, and used by prev/next
const initialState = {
    value: {
        page: 0,
        order: "desc",
        orderBy: "created",
        tags: [],
        allocated: "",
    },
}

export default function storyGridPagination(state = initialState, action) {
    switch (action.type) {
        case actions.SET_STORY_GRID_PAGINATION: {
            console.log("[redux] Setting story grid pagination value", action.payload.value)
            return {
                ...state,
                value: action.payload.value,
            }
        }

        default:
            return state
    }
}
